import React from 'react';

export default function Guidelines({ onBack }) {
  return (
    <div style={{
      fontFamily: "'Montserrat', sans-serif",
      /* Deep radial gradient for depth */
      background: 'radial-gradient(circle at 50% 0%, #1a2a40 0%, #0a1628 80%)',
      minHeight: '100vh',
      color: '#fff',
      position: 'relative',
      minHeight: '-webkit-fill-available',
      overflowX: 'hidden',
    }}>
      
      {/* Sticky Navigation Header with Glass Blur */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        paddingTop: 'calc(10px + env(safe-area-inset-top))',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '10px',
        background: 'linear-gradient(180deg, rgba(10,22,40,0.85) 0%, rgba(10,22,40,0) 100%)',
        pointerEvents: 'none' 
      }}>
        {/* Back Button - Pill Style */}
        <button 
          onClick={onBack}
          className="ios-button"
          style={{
            pointerEvents: 'auto',
            appearance: 'none',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: '30px',
            color: '#e6c57e',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.9rem',
            fontWeight: 600,
            letterSpacing: '0.05em',
            padding: '10px 20px 10px 16px',
            cursor: 'pointer',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            WebkitTapHighlightColor: 'transparent',
            transition: 'all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)',
          }}
        >
          <span style={{ fontSize: '1.2rem', lineHeight: 0, marginBottom: '2px' }}>←</span> Back
        </button>
      </div>

      {/* Main Scrollable Content */}
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '10px 20px 120px',
        paddingBottom: 'calc(120px + env(safe-area-inset-bottom))',
        boxSizing: 'border-box'
      }}>
        
        <h1 style={{
          fontFamily: "'Bodoni Moda', serif",
          fontSize: 'clamp(2.2rem, 6vw, 3.5rem)',
          background: 'linear-gradient(180deg, #e6c57e 20%, #bf953f 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-0.02em',
          fontWeight: 400,
          marginBottom: '30px',
          textAlign: 'center',
          lineHeight: 1.1,
          filter: 'drop-shadow(0px 4px 12px rgba(198,162,91,0.3))'
        }}>
          Guidelines & Community Standards
        </h1>

        {/* CARD 1: INTRO */}
        <div className="glass-card">
          <p style={{ marginBottom: '18px', fontSize: '0.9rem', color: '#a5adc4', lineHeight: 1.6 }}>
            <strong style={{ color: '#d65a5a' }}>IMPORTANT:</strong> These Community Guidelines (&quot;Guidelines&quot;) are a
            binding part of the terms and conditions governing your use of this application,
            website, and related services (collectively, the &quot;Service&quot;). By accessing
            or using the Service, you acknowledge that you have read, understood, and agree to be
            bound by these Guidelines in addition to our Terms of Use, Privacy Policy, and any
            other applicable policies (collectively, the &quot;Terms&quot;). In the event of a
            conflict between these Guidelines and the Terms, the Terms will control.
          </p>
          <p style={{ marginBottom: '0', fontSize: '0.95rem', lineHeight: 1.6, color: 'rgba(255,255,255,0.9)' }}>
            This space is intended for thoughtful, respectful image sharing. These Guidelines
            exist to promote safety, protect rights, and comply with applicable law. By posting
            or otherwise submitting content on or through the Service, you agree:
            (a) to comply with these Guidelines at all times; (b) that you are at least the age
            of majority where you live, or acting with appropriate parental/guardian consent as
            required by law; and (c) that your use of the Service will not violate any applicable
            law, regulation, or third-party right.
          </p>
        </div>

        {/* CARD 2: DEFINITIONS */}
        <div className="glass-card">
          <h2 className="card-title">Key Definitions</h2>
          <ul className="styled-list">
            <li>
              <strong>&quot;Content&quot;</strong> means any images, videos, text, captions,
              comments, metadata, or other material that you upload, post, display, transmit,
              or otherwise make available via the Service.
            </li>
            <li>
              <strong>&quot;User&quot; / &quot;you&quot;</strong> means any individual or
              entity that accesses or uses the Service in any manner.
            </li>
            <li>
              <strong>&quot;Minor&quot;</strong> means any person under eighteen (18) years
              of age or such higher age of majority as may be defined by applicable law in
              the relevant jurisdiction.
            </li>
            <li>
              <strong>&quot;Intimate imagery&quot;</strong> means nudity; the depiction of
              genitalia, buttocks, female nipples, or areas covered by underwear or swimwear;
              and/or any depiction of sexual activity or sexual arousal, whether real or simulated.
            </li>
            <li style={{ borderBottom: 'none' }}>
              References to <strong>&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;</strong> mean
              the operator of the Service and its affiliates, employees, contractors, and agents.
            </li>
          </ul>
        </div>

        {/* SECTION: NOT ALLOWED (Special Styling) */}
        <h3 className="section-header" style={{ color: '#e66b6b' }}>What you are NOT allowed to post</h3>
        <div className="glass-card" style={{ borderColor: 'rgba(230, 107, 107, 0.3)' }}>
          <ul className="styled-list">
            {[
              { title: 'Sexual content involving minors', text: 'absolutely prohibited. This includes any depiction, suggestion, or sexualization of a Minor, whether real, fictional, or simulated, including but not limited to intimate imagery, sexual acts, or fetish content that involves or appears to involve a Minor. We may report such content (and associated information) to law-enforcement and relevant authorities where required or appropriate.' },
              { title: 'Nudity & explicit sexual content', text: 'images focusing on genitalia, buttocks, female nipples, explicit sexual acts, or content primarily intended to be sexually arousing, including fetish content, pornography, or sexual services. Implied or partial nudity presented in a clearly sexualized or exploitative manner is also prohibited.' },
              { title: 'Non-consensual intimate imagery', text: 'any "revenge porn", secretly taken photos or videos, leaks, hacked content, deepfakes, or other intimate imagery shared without the clear, informed, and voluntary consent of the person(s) depicted. This includes attempts to threaten, extort, blackmail, or coerce anyone through the sharing or threatened sharing of intimate imagery.' },
              { title: 'Hate, discrimination & harassment', text: 'content that attacks, threatens, incites violence against, or degrades individuals or groups on the basis of protected characteristics (including, where applicable by law: race, ethnicity, nationality, caste, religion, disability, serious disease, sex, gender, gender identity, or sexual orientation), or content that targets individuals with bullying, doxxing, stalking, or sustained harassment. This includes the use of slurs, dehumanizing stereotypes, or symbols commonly associated with hate or genocide.' },
              { title: 'Graphic violence & gore', text: 'extremely graphic depictions of injury, mutilation, or death; content that glorifies, celebrates, or encourages violence; or material that is primarily intended to shock, horrify, or traumatize viewers.' },
              { title: 'Self-harm, suicide or eating disorder promotion', text: 'content that promotes, encourages, or instructs self-harm, suicide, or eating disorders. Discussion of recovery or support may be allowed if presented in a non-graphic, non-glorifying, and clearly supportive manner, but we may restrict such content to protect vulnerable users.' },
              { title: 'Illegal activities & dangerous acts', text: 'content that clearly depicts, facilitates, or promotes illegal activity (for example, serious property damage, distribution of hard drugs, non-consensual behavior, or criminal hacking), as well as dangerous stunts or challenges likely to result in serious injury or harm if copied.' },
              { title: 'Extremism & terrorism', text: 'praise, support, or propaganda for extremist or terrorist organizations, individuals, or ideologies, including recruitment material, glorification of attacks, or display of extremist symbols where the intent is supportive rather than critical or educational.' },
              { title: 'Commercial spam, fraud & scams', text: 'bulk or misleading promotional content, fake giveaways, investment schemes, impersonation of brands or individuals for deceptive purposes, phishing attempts, and any other content primarily intended to manipulate, deceive, or obtain something of value under false pretenses.' },
              { title: 'Impersonation & misrepresentation', text: 'posing as another person or entity without authorization, including using their name, likeness, or branding in a way that is likely to confuse or mislead others about your identity or affiliation.' },
              { title: 'Intellectual property & privacy violations', text: 'uploads that you do not have the legal right to share, including copyrighted photos, artwork, logos, or other protected material; trade secrets or confidential business information; or sensitive personal data (such as identification documents, medical records, or financial details) belonging to yourself or others. You are solely responsible for ensuring that you have all necessary rights, permissions, and licenses to post any Content.', noBorder: true }
            ].map((item, i) => (
              <li key={i} style={item.noBorder ? { borderBottom: 'none' } : {}}>
                <span style={{ color: '#e6c57e', fontWeight: 600, display: 'block', marginBottom: '4px' }}>{item.title}</span>
                <span style={{ opacity: 0.85 }}>– {item.text}</span>
              </li>
            ))}
          </ul>
          <div style={{ padding: '16px 20px', background: 'rgba(0,0,0,0.2)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
             <p style={{ margin: 0, fontSize: '0.85rem', color: '#a5adc4' }}>
              We reserve the right, in our sole discretion, to determine whether Content violates these Guidelines
              or is otherwise harmful, unlawful, or inappropriate for the Service, even if not explicitly listed above.
            </p>
          </div>
        </div>

        {/* SECTION: ALLOWED */}
        <h3 className="section-header" style={{ color: '#c6a25b' }}>What you CAN share here</h3>
        <div className="glass-card">
           <div style={{ padding: '20px' }}>
            <p style={{ marginBottom: '12px' }}>
              • <strong>Everyday life, aesthetics, and mood</strong> – light, texture, color, atmosphere, and composition that do not focus on explicit or harmful themes.
            </p>
            <p style={{ marginBottom: '12px' }}>
              • <strong>Portraits and people</strong> – where everyone is appropriately dressed under these Guidelines and has given any consent required by law and by these Guidelines for their image to be captured and shared.
            </p>
            <p style={{ marginBottom: '12px' }}>
              • <strong>Travel, streets, architecture, nature, objects, and abstractions</strong> – including creative explorations of space, design, and environment that respect the privacy and safety of others.
            </p>
            <p style={{ marginBottom: 0 }}>
              • <strong>Creative edits and filters</strong> – that transform your own original photos or other material that you are clearly and lawfully allowed to use (for example, licensed stock or works in the public domain), in compliance with any applicable license terms.
            </p>
           </div>
        </div>

        {/* CARD: PEOPLE & CONSENT */}
        <div className="glass-card">
          <h2 className="card-title">People, Consent & Privacy</h2>
          <ul className="styled-list">
            <li>You are responsible for obtaining any consent required by law from individuals who are identifiable in your Content, especially in private, intimate, or sensitive contexts (such as homes, hospitals, schools, or workplaces).</li>
            <li>Do not post images that could reasonably embarrass, expose, endanger, or harm someone’s reputation without their clear, informed permission. When in doubt, do not post.</li>
            <li>Blur or avoid showing identifiable details (faces, license plates, addresses, badges, or other unique identifiers) if the person did not agree to be photographed or if sharing those details could compromise their privacy or safety.</li>
            <li>Never share private or sensitive information about yourself or others, including but not limited to government IDs, passports, bank details, medical information, home addresses, phone numbers, or login credentials.</li>
            <li style={{ borderBottom: 'none' }}>You acknowledge that uploading Content of others without appropriate consent may violate privacy, publicity, or data-protection laws, and you agree to indemnify and hold us harmless from any resulting claims, to the fullest extent permitted by law.</li>
          </ul>
        </div>

        {/* CARD: AI & EDITS */}
        <div className="glass-card">
          <h2 className="card-title">AI-Generated, Synthetic & Edited</h2>
          <ul className="styled-list">
            <li>All rules in these Guidelines apply equally to AI-generated, synthetic, or heavily edited Content. It is not permitted to circumvent restrictions on explicit, hateful, or non-consensual material by labeling it as &quot;just AI&quot; or &quot;fictional.&quot;</li>
            <li>Do not create or upload fake intimate imagery, deepfakes, or other synthetic depictions of real people (including public figures, celebrities, or people you know) without their explicit permission, particularly where such Content is sexual, violent, defamatory, or otherwise harmful.</li>
            <li>Do not generate or share synthetic imagery that is likely to materially mislead others about real-world events (for example, fabricated crimes, disasters, or official actions) in a way that could cause public harm, panic, or serious reputational damage.</li>
            <li style={{ borderBottom: 'none' }}>Where your Content is heavily AI-generated, composited, or synthetic, you should be honest about that in the caption or description when it would be reasonably important for viewers to know (for example, when portraying public figures or sensitive events).</li>
          </ul>
        </div>

        {/* CARD: REPORTING */}
        <div className="glass-card">
          <h2 className="card-title">Reporting, Moderation & Authorities</h2>
          <p style={{ padding: '0 20px 10px', margin: 0, color: '#d4d4d0' }}>If you see Content that you believe violates these Guidelines or applicable law:</p>
          <ul className="styled-list">
            <li>Use the in-app reporting tools (where available) or contact support using the method described in the Service (for example, via in-app forms or <span style={{ fontStyle: 'italic', color: '#e6c57e' }}>[amishabansal21@gmail.com]</span>).</li>
            <li>Avoid engaging directly with abusive users or attempting to retaliate. Instead, report the issue and, where appropriate, block the user.</li>
            <li>For any situation involving immediate danger, violence, or criminal activity in the real world, contact your local law-enforcement or emergency services <strong>first</strong>. The Service is not a substitute for emergency assistance.</li>
          </ul>
          <div style={{ padding: '16px 20px', background: 'rgba(0,0,0,0.2)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#a5adc4' }}>
              We may, in our sole discretion, review, monitor, and moderate Content, but we are not obligated to do so
              and do not guarantee that we will remove all Content that you might find objectionable. Where required or
              permitted by law, we may preserve and disclose information (including Content, account data, and IP
              addresses) to law-enforcement, regulators, or other parties in connection with investigations or legal
              proceedings.
            </p>
          </div>
        </div>

        {/* CARD: ENFORCEMENT */}
        <div className="glass-card">
          <h2 className="card-title">Enforcement & Consequences</h2>
          <ul className="styled-list">
            <li><strong>Content moderation:</strong> We may remove, hide, restrict, age-gate, or add warnings to any Content that we believe violates these Guidelines or applicable law, or that we otherwise deem harmful or inappropriate, with or without prior notice.</li>
            <li><strong>Account restrictions:</strong> We may temporarily limit features on your account, including your ability to post, comment, message, or interact, particularly where we detect repeated or borderline violations.</li>
            <li><strong>Account suspension or termination:</strong> We may suspend or permanently terminate your access to the Service, in whole or in part, for serious, repeated, or intentional violations – especially in cases involving child safety, non-consensual intimate imagery, threats, serious harassment, or promotion of violence or extremism.</li>
            <li><strong>Legal reporting:</strong> Where required or appropriate, we may report suspected illegal activity (including child sexual exploitation, credible threats of violence, or serious hacking/fraud) to law-enforcement or other relevant authorities and cooperate with their requests.</li>
            <li style={{ borderBottom: 'none' }}><strong>No entitlement to restoration or refund:</strong> Enforcement actions are taken at our sole discretion. Unless required by law, you are not entitled to restoration of removed Content, reactivation of an account, or any refund or credit as a result of moderation or enforcement decisions.</li>
          </ul>
        </div>

        {/* CARD: SAFETY TIPS */}
        <div className="glass-card" style={{ borderStyle: 'dashed', borderColor: 'rgba(198,162,91,0.4)' }}>
           <h2 className="card-title">Keep Yourself Safe</h2>
           <ul className="styled-list">
            <li>Be thoughtful about what you share publicly – once Content is posted online, it may be copied, saved, or redistributed outside your control. Consider how you might feel about the Content in the future.</li>
            <li>Avoid sharing images that reveal your exact home address, school, workplace, daily routine, or other sensitive locations or patterns that could be used to track or target you.</li>
            <li>Be cautious when interacting with people you do not know offline. Do not share passwords, financial information, or other sensitive details with anyone you meet through the Service.</li>
            <li style={{ borderBottom: 'none' }}>If something feels off or unsafe, trust that feeling: you are not required to respond, engage, or post. You can use reporting and blocking tools, and you can always choose to step away from the Service.</li>
           </ul>
        </div>

        {/* Footer Legal Note */}
        <p style={{
          marginTop: '40px',
          fontSize: '0.85rem',
          color: 'rgba(255,255,255,0.4)',
          textAlign: 'center',
          lineHeight: 1.5
        }}>
          These Guidelines do not constitute legal advice and may not address every possible situation. They may be
          updated, supplemented, or revised from time to time, including to reflect changes in our Service, applicable
          laws, or industry standards. We may do so with or without prior notice, as permitted by law. By continuing
          to use the Service after any update, you agree to the then-current version of these Guidelines and the Terms.
          If you do not agree, you must stop using the Service.
        </p>

      </div>

      {/* CSS Styling Injection */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;1,6..96,400&family=Montserrat:wght@300;400;500;600;700&display=swap');
        
        /* Glass Card Container Style */
        .glass-card {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(30px);
          -webkit-backdrop-filter: blur(30px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          margin-bottom: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          overflow: hidden; /* Keeps list borders inside */
        }

        /* Section Headers */
        .section-header {
          font-family: 'Montserrat', sans-serif;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: rgba(255,255,255,0.6);
          margin-bottom: 12px;
          padding-left: 10px;
          font-weight: 600;
        }

        /* Card Titles */
        .card-title {
          font-family: 'Bodoni Moda', serif;
          font-size: 1.35rem;
          font-weight: 400;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #e6c57e;
          margin: 0;
          padding: 20px 20px 10px;
        }

        /* Styled "Settings" Lists */
        .styled-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .styled-list li {
          padding: 16px 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          font-size: 0.95rem;
          line-height: 1.6;
          color: rgba(235, 235, 235, 0.9);
        }

        /* Button Press Effect */
        .ios-button:active {
          transform: scale(0.92);
          background: rgba(198,162,91,0.15) !important;
          border-color: #c6a25b !important;
        }

        html { scroll-behavior: smooth; }
      `}</style>
    </div>
  );
}